/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import WysiwygIcon from '@mui/icons-material/Wysiwyg';

const baseFetchDatasetsEndpoint = '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=fetchRedlineDatasets'
const baseEndpoint = '/HttpTriggerAdasPrograms'


const createAdasProgramsItemDetailsPageLink = (adasProgramId: string, programName: string, modelYear: string, tabName: string) => {
  const url = `${ADAS_PROGRAMS_CONSTANTS.itemDetailsRoute}?adasProgramId=${adasProgramId}&programName=${programName}&modelYear=${modelYear}
  &${ADAS_PROGRAMS_CONSTANTS.itemDetails.horizontalTabs.pageHtabs.tabNameUrlKey}=${tabName}`
  // encode url
  const encodedUrl = encodeURI(url)
  return encodedUrl
}

const ADAS_PROGRAMS_CONSTANTS = {
  sidebar: {
    title: 'ADAS Programs',
    icon: <WysiwygIcon style={{
      width: "30px",
      height: "50px",
    }}/>
  },
  mainRoute: '/adas-programs',
  table: {},
  itemDetailsRoute: '/adas-programs-details',
  itemDetails: {
    coverageRequirements: {
      saveDatasetsForTreeEndpoint: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=saveDatasetsForTree',
      fetchDatasetsForTreeEndpoint: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=fetchDatasetsForTree',
      fetchDatasetsEndpoint: baseFetchDatasetsEndpoint,
      fetchFilteredDatasetsEndpoint: `${baseFetchDatasetsEndpoint}&shouldFilter=true`,
      fetchReportFormatsEndpoint: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=fetchReportFormats',
      fetchOrSaveCoverageRequirementsMetaDataEndpoint: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=fetchOrSaveCoverageRequirementsMetaData',
      saveFilteredDatasetsEndpoint: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=saveFilteredDatasets',
      getSaveOrFetchDatasetsEndpoint: (requestType: string) => `/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=saveFilteredDatasets&saveOrFetch=${requestType}`,
      fetchObjectsFromRedlineDatasetEndpoint: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=fetchObjectsFromRedlineDataset',
      viewReportRoute: '/adas-programs-details/view-report',
      checkDeleteReportEndpoint: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=checkIfDeleteReportValid',

      reportTypes: new Set([188, 141]),
      folderIntItemTypes: new Set([30, 31, 32])
    },
    sensorBom: {
      saveProgramPropertiesEndpoint: '/HttpTriggerAdasPrograms?page=sensorBom&requestType=saveProgramProperties',
      fetchProgramPropertiesEndpoint: '/HttpTriggerAdasPrograms?page=sensorBom&requestType=fetchProgramProperties',
      isSensorBomReadOnly: '/HttpTriggerAdasPrograms?page=sensorBom&requestType=isSensorBomReadOnly',
      sensorBomReadOnlyDevStagesMessage: 'BOM is read-only because vehicle programs have development stages for this ADAS program.'
    },
    vehiclePrograms: {
      // pageLink: `${baseEndpoint}?page=vehiclePrograms`,
    },
    horizontalTabs: {
      pageHtabs: {
        tabIndexUrlKey: 'htabs-1',
        tabNameUrlKey: 'htabs-1-name',
      }
    }
  },
  landingPage: {
    checkIsDeleteProgramValid: `${baseEndpoint}?page=landingTable&requestType=shouldDeleteProgram`,
    deleteProgram: `${baseEndpoint}?page=landingTable&requestType=deleteProgram`,
  },
  linkFunctions: {
    itemDetailsMainHTabs: createAdasProgramsItemDetailsPageLink
  }
}

export default ADAS_PROGRAMS_CONSTANTS